import ajax from '../http/ajax'

// 特价推广、聚合推广门店列表（不分页，地图）
export const getAllStoreList = data => {
    return ajax.get('getAllStoreList', data)
}

// 特价推广、聚合推广门店列表（分页）
export const getNearbySstores = data => {
    return ajax.get('getNearbySstores', data)
}

// 商家推广门店（地图）
export const getBusinessSstoreListMap = data => {
    return ajax.get('getBusinessSstoreListMap', data)
}

// 商家推广（分页）
export const getSpecSstores = data => {
    return ajax.get('getSpecSstores', data)
}

export const getClosestSstores = data => {
    return ajax.get('getClosestSstores', data)
}

/** 获取分销门店列表 */
export const getDistributioStroreList = data => {
    return ajax.get('getDistributioStroreList', data)
}
